module.exports = __webpack_public_path__ + "static/media/pdf-preview.9076d46d.jpg";